import { useParams } from "react-router-dom";
import BackButton from "../ui/back";
import { useDispatch, useSelector } from "react-redux";
import { fetchCourseGroups } from "../../redux/action";
import CourseHeroCard from "../dashboard/Hero/Newhero/CourseHeroCard";
import { useEffect, useMemo, useState } from "react";
import CourseDetailsTabs from "../courseDetails/tabs";
import AboutCourseSection from "../aboutCourse";
import Resources from "../courseDetails/resources";
import ProjectDeliverables from "./tabs/deliverables";
import ProjectMeetings from "./tabs/meetings";
import ProjectMentor from "./tabs/mentor";
import SimilarProjectCard from "./similarProjectCard";
import CoursePageLoader from "../ui/CoursePageLoader";

const ProjectDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { courseGroups, user } = useSelector((state) => state);
  const [tabs, setTabs] = useState("about");

  const enrolled = useMemo(() => {
    const courses = user?.enrolledCourses || user?.enrolled_courses || [];
    return courses.some((c) => {
      const cid = typeof c === "object" ? c.id || c.course_id : c;
      return Number(cid) === Number(id);
    });
  }, [user, id]);

  const similarProjects = useMemo(() => {
    return (courseGroups?.data?.data || [])
      .filter(
        (c) => c.id !== parseInt(id) && c.course_type?.type === "project",
      )
      .slice(0, 3);
  }, [courseGroups, id]);

  useEffect(() => {
    // If we haven't loaded them, dispatch it
    if (!courseGroups || !courseGroups.data) {
      dispatch(fetchCourseGroups());
    }
  }, [dispatch, courseGroups]);

  let course = null;
  if (courseGroups && Array.isArray(courseGroups.data?.data)) {
    course = courseGroups.data.data.find((c) => c.id === parseInt(id));
  }
  let sectionStr = "project";

  if (!course) {
    return <CoursePageLoader message="Loading project details..." />;
  }

  return (
    <div>
      <div className="bg-[#F8D2100D]">
        <div className="px-6 lg:px-[120px] pt-6 mx-6">
          <BackButton />
        </div>
        <>
          <CourseHeroCard section={sectionStr} course={course} />
          <div className="mt-[40px] md:py-[40px] md:px-[120px] p-4 bg-[#FCF8E3]">
            <CourseDetailsTabs
              tabs={tabs}
              setTabs={setTabs}
              section={sectionStr}
            />

            {tabs === "about" && (
              <AboutCourseSection course={course} section={sectionStr} />
            )}
            {tabs === "deliverables" &&
              (!enrolled ? (
                <ProjectDeliverables course={course} />
              ) : (
                <div className="py-10 my-4 text-sm md:text-base text-center text-[#828282] bg-white ">
                  Enroll to see deliverable information
                </div>
              ))}
            {tabs === "resources" &&
              (!enrolled ? (
                <Resources course={course} type="project" />
              ) : (
                <div className="py-10 my-4 text-[#828282] text-sm md:text-base text-center bg-white ">
                  Enroll to see resource information
                </div>
              ))}
            {tabs === "meetings" &&
              (enrolled ? (
                <ProjectMeetings course={course} />
              ) : (
                <div className="py-10 my-4 text-sm md:text-base text-[#828282] text-center bg-white ">
                  Enroll to see meeting information
                </div>
              ))}
            {tabs === "mentor" && <ProjectMentor course={course} />}
          </div>
        </>
      </div>
      {similarProjects.length > 0 && (
        <div className="lg:px-[120px] lg:pb-[40px] p-4 bg-white mt-[16px]">
          <h2 className="font-bold lg:py-[20px] py-4 text-secondary text-[28px]">
            Similar Projects
          </h2>
          <div className="max-tab:py-3 grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 pt-6">
            {similarProjects.map((similarProject) => (
              <SimilarProjectCard
                key={similarProject.id}
                project={similarProject}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProjectDetails;
